// DS: i4.12
import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import IconWrap from '../IconWrap';
const Recommended = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12.7247 20.1346L12 22l-.7247-1.8654a13 13 0 00-7.41-7.41L2 12l1.8654-.7247a13 13 0 007.41-7.41L12 2l.7247 1.8654a13 13 0 007.41 7.41L22 12l-1.8654.7247a13 13 0 00-7.41 7.41z",
        fillRule: "evenodd"
    })));
};
Recommended.displayName = 'Recommended';
export default Recommended;
